import apiEndPoints from "../../utils/apiEndPoints";
import { apiCall } from "../../utils/httpClient";

const getDashboardDetail = async (params) => {
  const data = await apiCall("post", apiEndPoints.DASHBOARDDETAILADMIN, params);
  return data;
};
const getDashboardGraph = async (params) => {
  return await apiCall("post", apiEndPoints.DASHBOARDGRAPH, params);
};

const getNewDashboardDetails = async (params) => {
  const data = await apiCall("post", apiEndPoints.DASHBOARDDETAILS, params);
  return data;
};

const getDashboardSourcing = async (params) => {
  const data = await apiCall("post", apiEndPoints.DASHBOARDSOURCING, params);
  return data;
};

const getDashboardClosing = async (params) => {
  const data = await apiCall("post", apiEndPoints.DASHBOARDCLOSING, params);
  return data;
};

const getDashboardSCM = async (params) => {
  const data = await apiCall("post", apiEndPoints.DASHBOARDSCM, params);
  return data;
};

const getDashboardSiteHead = async (params) => {
  const data = await apiCall("post", apiEndPoints.DASHBOARDSITEHEAD, params);
  return data;
};

const getDashboardReceiptionist = async (params) => {
  const data = await apiCall("post", apiEndPoints.DASHBOARDRECEPTIONIST, params);
  return data;
};

const getDashboardPostSale = async (params) => {
  const data = await apiCall("post", apiEndPoints.DASHBOARDPOSTSALE, params);
  return data;
};

const getDashboardCstl = async (params) => {
  const data = await apiCall("post", apiEndPoints.DASHBOARDCSTL, params);
  return data;
};


const dashboardService = {
  getDashboardDetail,
  getDashboardGraph,
  getNewDashboardDetails,
  getDashboardSourcing,
  getDashboardClosing,
  getDashboardSCM,
  getDashboardSiteHead,
  getDashboardReceiptionist,
  getDashboardPostSale,
  getDashboardCstl,
};

export default dashboardService;
